/**
 * Opens the combined Utility Details modal (overview + company + bill + usage).
 * Kept as a named wrapper so existing dashboard / solar-card call sites stay unchanged.
 */
import React from 'react';
import UtilityDetailsModal from './UtilityDetailsModal';
import type { UtilityDetailsPopupModalProps } from './UtilityDetailsPopupModal.types';

export type { UtilityDetailsPopupModalProps } from './UtilityDetailsPopupModal.types';

export const UtilityDetailsPopupModal: React.FC<UtilityDetailsPopupModalProps> = ({ open, onClose }) => {
    return (
        <UtilityDetailsModal
            open={open}
            onClose={onClose}
            oppId={sessionStorage.getItem('SalesForceId')}
            initialTab="overview"
        />
    );
};

export default UtilityDetailsPopupModal;
